// extracted by mini-css-extract-plugin
export default {"box":"addHeaders_box__LhQxf","title":"addHeaders_title__8n+Nv"};